import SchoolHighlights from './SchoolHighlights'


export default SchoolHighlights
